import { render, staticRenderFns } from "./FileSidebar.vue?vue&type=template&id=63bc83c5&scoped=true"
import script from "./FileSidebar.vue?vue&type=script&lang=js"
export * from "./FileSidebar.vue?vue&type=script&lang=js"
import style0 from "./FileSidebar.vue?vue&type=style&index=0&id=63bc83c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bc83c5",
  null
  
)

export default component.exports